import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { AppState } from './types';

export const getters: GetterTree<AppState, RootState> = {};
